import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";

function NoFollowings(): React.JSX.Element {
  return (
    <View style={styles.container}>
      <MaterialCommunityIcons
        name="account-group-outline"
        size={100}
        color="#888"
      />
      <Text style={styles.emptyTitle}>No followings yet.</Text>
      <Text style={styles.emptyText}>Encourage them to follow you.</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    backgroundColor: "white",
    flex: 1,
    justifyContent: "center",
    paddingHorizontal: 20,
  },
  emptyText: {
    color: "#888",
    fontSize: 16,
    lineHeight: 24,
    marginTop: 10,
    textAlign: "center",
  },
  emptyTitle: {
    color: "#888",
    fontSize: 20,
    fontWeight: "bold",
    marginTop: 20,
    textAlign: "center",
  },
});

export default NoFollowings;
